module.exports = __webpack_public_path__ + "img/gilbert.d076e52a.jpeg";